import {CornerDownIcon} from '@yandex-delivery/blocks'
import React from 'react'
import type {
  DetailsSection,
  DetailsSectionItem,
  DetailsSectionItemAccordion,
  DetailsSectionItemSubtitle,
} from 'src/api/types'

import {Accordion, AccordionDetails, AccordionSummary} from '../accordion'
import {Item, List} from '../info'
import {classes} from '../info/styles'

const isDetailsSectionItemAccordion = (sectionItem: DetailsSectionItem): sectionItem is DetailsSectionItemAccordion => {
  return sectionItem.type === 'accordion'
}

const isDetailsSectionItemSubtitle = (sectionItem: DetailsSectionItem): sectionItem is DetailsSectionItemSubtitle => {
  return sectionItem.type === 'subtitle'
}

type Props = {
  sections: DetailsSection[]
}

const DetailsList: React.FC<Props> = ({sections}) => {
  return (
    <>
      {sections.map((section, indexList) => {
        return (
          <List key={`list_${indexList}`} title={section.title}>
            {section.items.map(item => {
              if (isDetailsSectionItemSubtitle(item)) {
                return (
                  <Item description={item.subtitle} key={item.title}>
                    {item.title}
                  </Item>
                )
              }
              if (isDetailsSectionItemAccordion(item)) {
                return (
                  <Accordion key={item.title}>
                    <AccordionSummary expandIcon={<CornerDownIcon data-e2e="info-partner" />}>
                      <div className={classes.primary}>{item.title}</div>
                    </AccordionSummary>
                    <AccordionDetails>
                      {item.items.map(subItem =>
                        'title' in subItem ? (
                          subItem.subtitle ? (
                            <Item description={subItem.subtitle} key={subItem.title}>
                              {subItem.title}
                            </Item>
                          ) : (
                            <div className={classes.item} key={subItem.title}>
                              <div className={classes.secondary}>{subItem.title}</div>
                            </div>
                          )
                        ) : null,
                      )}
                    </AccordionDetails>
                  </Accordion>
                )
              }

              return null
            })}
          </List>
        )
      })}
    </>
  )
}

export default DetailsList
